export default "__VITE_ASSET__Brvw_mMo__"